<template>
  <div class="change-password-wrapper">
    <div class="change-password-container">
      <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
      <div class="back-block" @click="$router.push({ name: 'settings' })">
        <img
          src="../../../public/custom/images/back-arrow.svg"
          class="back-img"
          alt="Back arrow"
        />
        <span class="back-btn-text">{{ $t('message.loanPage.back') }}</span>
      </div>
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.oldPassword.label')"
          v-model="old_password"
          :validate-rules="'password'"
          :name="'password'"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.newPassword.label')"
          v-model="new_password"
          :validate-rules="'password'"
          :name="'password'"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-password-input
          :label="$t('message.changePasswordPage.confirmPassword.label')"
          v-model="confirmPassword"
          :name="'passwordConfirmation'"
          :validate-rules="`passwordConfirmation:${this.new_password}`"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="password-container">
        <base-otp-input
          v-model="otp"
          @getOtpCode="getOtpCode()"
          :disabled="isSaveBtnLoading"
        />
      </div>
      <div class="btns-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.changePasswordPage.btnSave')"
            class="save-btn"
            :disabled="isSaveBtnDisabled"
            :is-loading="isSaveBtnLoading"
            @click="changePassword()"
          />
        </div>

        <div class="btn-container">
          <base-button
            :text="$t('message.changePasswordPage.btnCancel')"
            class="cancel-btn"
            @click="$router.push({name: 'settings'})"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePasswordInput from '../../components/base/BasePasswordInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseOtpInput from '../../components/base/BaseOtpInput.vue';

export default {
  name: 'ChangePassword',
  inject: ['$httpService'],
  components: {
    BasePasswordInput,
    BaseButton,
    BaseOtpInput
  },
  data() {
    return {
      old_password: '',
      new_password: '',
      confirmPassword: '',
      otp: '',
      message_id: '',
      isSaveBtnLoading: false
    }
  },
  methods: {
    async getOtpCode() {
        try {
          const response = await this.$httpService.auth.getAuthorizedOtpCode();

          this.message_id = response.data.message_id;
          this.$toast.success(this.$t('message.signIn.otpToastMsg'));
        } catch (error) {
          this.$router.push({name: 'settings'});
        }
    },
    async changePassword() {
      this.isSaveBtnLoading = true;

      const payload = {
        old_password: this.old_password,
        new_password: this.new_password,
        otp: +this.otp
      }

      try {
        const response = await this.$httpService.msi.changePassword(payload);

        if (response.data) {
          this.$toast.success(this.$t('message.changePasswordPage.toastMsg'));
          this.isSaveBtnLoading = false;
          this.$router.push({name: 'settings'});
        }
      } catch (error) {
        this.isSaveBtnLoading = false;
      }
    }
  },
  computed: {
    isSaveBtnDisabled() {
      return this.isFieldsEmpty || this.isHasErrors;
    },
    isFieldsEmpty() {
      return !this.old_password || !this.new_password || !this.confirmPassword || !this.otp;
    },
    isHasErrors() {
      return this.errors.items.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .change-password-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 20px;
    box-sizing: border-box;
  }

  .change-password-container {
    @include base-page-container;
    flex-direction: column;
  }

  .password-container {
    width: 343px;
    margin-bottom: 5px;
  }

  .btns-block {
    display: flex;
    margin-top: 20px;
    margin-bottom: 50px;
  }

  .btn-container {
    width: 200px;
    height: 40px;
  }

  .cancel-btn {
    margin-left: 20px;
  }

  .cancel-btn ::v-deep {
      background-color: white;
      color: #41BF7B;
      border: 2px solid #41BF7B;
      transition: all 0.2s ease;

      &:hover {
        transform: scale(1.01);
      }
  }

  .save-btn ::v-deep {
    border: 2px solid #41BF7B;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.01);
    }
  }

  .save-btn ::v-deep.disabled {
    border: 2px solid rgba(64, 191, 123, 0.1);
  }

  .password-container ::v-deep .input-label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #7A7A7A;
  }

  .password-container ::v-deep .input-block {
    height: 40px;
    min-height: 40px;
    border-radius: 6px;
  }

  .password-container ::v-deep .input {
    height: 38px;
    min-height: 38px;
    padding: 8px;
    font-size: 14px;
    line-height: 24px;
  }

  .password-container ::v-deep .eye-img {
    width: 24px;
    height: 24px;
  }

  .password-container ::v-deep .error-block {
    height: 16px;
    margin-top: 2px;
    font-size: 12px;
  }

  .btn-container ::v-deep .button {
    min-height: 40px;
    max-height: 40px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 24px;
  }

  .route-name {
    @include route-name;
    margin-bottom: 15px;
  }

  .back-block {
    width: fit-content;
    height: 40px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .back-img {
    margin-right: 4px;
    height: 18px;
    width: 18px;
  }

  .back-btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: #878787;
  }

  @media screen and (max-width: 510px) {
    .password-container {
      width: 100%;
    }

    .btns-block {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .btn-container {
      width: 70%;
    }

    .btn-container:first-of-type {
      margin-bottom: 20px;
    }

    .cancel-btn {
      margin-left: 0;
    } 
  }
</style>